const findImages = () => {
    const images = [...document.querySelectorAll('.img-tiny__wrapper')];
    return images.filter(img => img.querySelector('img.img-tiny[data-src]'));
};

const showImage = imageWrapper => {
    const small = imageWrapper.querySelector('.img-tiny')
    const  img = new Image();
    img.onload = function () {
        imageWrapper.classList.add('loaded');
        imageWrapper.appendChild(img);
    };

    img.src = small.dataset.src;
};

const showImages = imageWrappers => {
    imageWrappers.forEach(imgWrapper => showImage(imgWrapper));
};

const init = () => {
    showImages(findImages());
};

setTimeout(() => {
    init();
}, 10);

// window.addEventListener('load', init);



// WEBPACK FOOTER //
// ./js/img-tiny.js